export default __webpack_public_path__ + "static/tins-5c43c6b27a783465a34c0382f4ba6b3d.png";